module.exports = __webpack_public_path__ + "static/media/login.465c0f61.jpg";